import { Reducer } from "redux"
import { AuthUserType, HeroType } from "../../Actions/Types"
import { APIHero } from "../../Models/API/APIHero"
import { FetchState } from "../../Models/Client/FetchState"
import { Result } from "../../Models/Utility/Result"
import { AuthAction } from "../Auth"

export interface HeroState {
    [id: string]: FetchState<APIHero>
}

interface HeroSetAction {
    type: HeroType.set
    payload: APIHero
}

export type HeroAction = HeroSetAction

const initialState: HeroState = {}

export const HeroReducer: Reducer<HeroState, HeroAction | AuthAction> = (
    state = initialState,
    action
): HeroState => {
    switch (action.type) {
        case HeroType.set:
            return {
                ...state,
                [action.payload.id]: Result.ok(action.payload)
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
